<template>
  <div class="scroll-visible" :style="visibleStyle">
    <!-- 滚动元素 -->
    <div class="scroll-content" ref="scrollContent" @scroll="scrollEvent">
      <!-- 画布 -->
      <div id="editor" style="margin-bottom: 100px;"></div>
      <!-- 设置路径动画 -->
      <setPathAnim></setPathAnim>
      <!-- 设置镜头 -->
      <setCamera></setCamera>
      <!-- 正在加载部分 -->
      <div v-show="isloading" class="loading-box" :style="loadingStyle">
        <div>正在加载...</div>
      </div>
      <!-- 播放遮罩 -->
      <div
        v-show="!UserMsg.payForMaterial && scenesPlay && IsVipSprites && IsVipSprites.dataLength"
        class="vip-mask"
        :style="vipMaskStyle"
      >
        <div v-if="TOOL&&TOOL.optimized != 'Horizontal'" class="contain-vips"></div>
        <div v-else>视频中含有VIP素材或功能</div>
      </div>
      <div v-show="scenesPlay && UserLevel<=0" class="preview-watermark" :style="watermarkStyle"></div>
    </div>
    <!-- y轴滚动条 -->
    <div v-show="showScrollY" class="scroll-dragger scroll-y">
      <div v-dragHandle data-action="y" class="handle-y" :style="handleyStyle"></div>
    </div>
    <!-- x轴滚动条 -->
    <div v-show="showScrollX" class="scroll-dragger scroll-x">
      <div v-dragHandle data-action="x" class="handle-x" :style="handlexStyle"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import setPathAnim from "./setPathAnim.vue"; // 路径动画
import setCamera from "./setCamera.vue"; // 路径动画

export default {
  data() {
    return {
      showScrollX: false, // 判断x轴元素是否显示
      showScrollY: false, // y轴是否显示
      scenesPlay: false,
      visibleData: {
        // 显示元素的宽高
        width: 0,
        height: 0
      },
      handleY: {
        // y轴元素的信息
        height: 0,
        top: 0
      },
      handleYDown: 0, // 用于拖动的初始值
      handleX: {
        width: 0,
        left: 0
      },
      handleXDown: 0,
      scrollInfo: {
        // 滚动时滚动的信息
        left: 0,
        top: 0,
        height: 0,
        width: 0
      },
      isloading: false,
      loadingInfo: {
        top: 0,
        left: 0
      }
    };
  },
  computed: {
    ...mapGetters([
      "Tool_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "TOOL",
      "IsVipSprites",
      "UserLevel",
      "UserMsg"
    ]),
    // 对应的样式
    visibleStyle() {
      const style = {};
      style.width = this.visibleData.width + "px";
      style.height = this.visibleData.height + "px";
      return style;
    },
    handleyStyle() {
      const style = {};
      // let height = ;
      style.height = this.handleY.height + "px";
      style.top = this.handleY.top + "px";
      return style;
    },
    handlexStyle() {
      const style = {};
      style.width = this.handleX.width + "px";
      style.left = this.handleX.left + "px";
      return style;
    },
    loadingStyle() {
      const style = {};
      style.top = this.loadingInfo.top - 35 + "px";
      style.left = this.loadingInfo.left - 50 + "px";
      return style;
    },
    vipMaskStyle() {
      const style = {};
      let type = "";
      this.TOOL && (type = this.TOOL.optimized || "Vertical");
      if (type === "Horizontal") {
        style.top =
          this.TOOL.fixTop +
          (this.TOOL.clientHeight - 140 / this.TOOL.scale) / 2 -
          40 +
          "px";
        style.left = this.TOOL.fixLeft + "px";
        style.width = this.TOOL.clientWidth + "px";
        style.fontSize = 140 / this.TOOL.scale + "px";
      } else if (type === "Vertical") {
        style.top = this.TOOL.fixTop + "px";
        style.left = this.TOOL.fixLeft + "px";
        style.width = this.TOOL.clientWidth + "px";
        style.height = this.TOOL.clientHeight + "px";
      }

      return style;
    },
    watermarkStyle() {
      const style = {};
      let type = "";
      this.TOOL && (type = this.TOOL.optimized || "Vertical");
      if (type === "Horizontal") {
        style.width = this.TOOL.clientWidth + "px";
        style.height = this.TOOL.clientHeight + "px";
        style.top = this.TOOL.fixTop + "px";
        style.left = this.TOOL.fixLeft + "px";
        style.background =
          "url('../../../static/animengine/img/icon-default-watermark-h.png') 50% 50% / 100% 100% no-repeat";
      } else if (type === "Vertical") {
        let clientWidth = (this.TOOL.clientHeight * 9) / 16,
          clientHeight = this.TOOL.clientHeight;
        style.width = clientWidth + "px";
        style.height = clientHeight + "px";
        style.top = this.TOOL.fixTop + "px";
        style.left = this.TOOL.fixLeft + this.TOOL.clientWidth * 0.3418 + "px";
        style.background =
          "url('../../../static/animengine/img/icon-default-watermark-v.png') 50% 50% / 100% 100% no-repeat";
      }
      return style;
    }
  },
  watch: {
    TOOL: function(val, oldval) {
      if (!oldval && val) {
        this.changeVisibleData();
        this.initData();
      }
    },
    "Tool_Size.width": function(val, oldval) {
      if (val > oldval) {
        this.changeVisibleData();
        this.initData();
      }
    },
    "Tool_Size.height": function(val, oldval) {
      if (val > oldval) {
        this.changeVisibleData();
        this.initData();
      }
    },
    "TOOL.option.scale": function(val, oldval) {
      this.changeVisibleData();
      this.initData();
    },
    "TOOL.loading.status": function(val, oldval) {
      if (val === "loading") {
        this.isloading = true;
      } else if (val === "success") {
        this.isloading = false;
      } else if (val === "fail") {
        this.isloading = false;
        this.$message({
          showClose: true,
          message: "加载失败",
          type: "error"
        });
      }
    }
  },
  mounted() {
    this.$bus.on("EditorSetOption_vue", data => {
      if (data.data) {
        this.editorOption();
      }
    });
    this.$bus.on("timeline_play_scenes", data => {
      data && (this.scenesPlay = data.forWater);
    });
    this.changeVisibleData();
  },
  methods: {
    editorOption() {
      if (this.TOOL) {
        let timeoutid = setTimeout(() => {
          this.TOOL.setOption({
            width: this.Tool_Size.width,
            height: this.Tool_Size.height - 40,
            surplusY: this.TopNav_Size.height + 40,
            surplusX: this.MaterialPane_Size.width
          });
          this.changeVisibleData();
          this.initData();
          clearTimeout(timeoutid);
        }, 280);
      }
    },
    initData() {
      // 滚动条的显示数据初始化
      if (this.Tool_Size.height < this.TOOL.option.height) {
        this.showScrollY = true;
        this.handleY.height =
          (this.visibleData.height * this.visibleData.height) /
          this.TOOL.option.height;
      } else {
        this.showScrollY = false;
        this.handleY.height = 0;
      }
      if (this.Tool_Size.width < this.TOOL.option.width) {
        this.showScrollX = true;
        this.handleX.width =
          (this.Tool_Size.width * this.Tool_Size.width) /
          this.TOOL.option.width;
      } else {
        this.showScrollX = false;
        this.handleX.width = 0;
      }
      this.loadingInfo.top = this.TOOL.option.height / 2 - 10;
      this.loadingInfo.left = this.TOOL.option.width / 2 - 20;
    },
    changeVisibleData() {
      // 显示框的宽高
      this.visibleData.width = this.Tool_Size.width;
      this.visibleData.height = this.Tool_Size.height - 40;
    },
    scrollEvent(e) {
      // scroll事件
      if (this.Tool_Size.height >= this.TOOL.clientHeight) {
        e.target.scrollTop = 0;
      } else if (
        this.visibleData.height < this.TOOL.clientHeight &&
        e.target.scrollTop > this.TOOL.clientHeight - this.visibleData.height
      ) {
        e.target.scrollTop = this.TOOL.clientHeight - this.visibleData.height;
      }

      if (this.Tool_Size.width >= this.TOOL.clientWidth) {
        e.target.scrollLeft = 0;
      } else if (
        this.visibleData.width < this.TOOL.clientWidth &&
        e.target.scrollLeft > this.TOOL.clientWidth - this.visibleData.width
      ) {
        e.target.scrollLeft = this.TOOL.clientWidth - this.visibleData.width;
      }

      this.scrollInfo.height = e.target.scrollHeight;
      this.scrollInfo.width = e.target.scrollWidth;
      this.scrollInfo.top = e.target.scrollTop;
      this.scrollInfo.left = e.target.scrollLeft;

      this.TOOL.changePfix({
        surplusY: this.TopNav_Size.height + 40 - this.scrollInfo.top,
        surplusX: this.MaterialPane_Size.width - this.scrollInfo.left
      });

      // 更改vuex中的数据
      this.$store.commit("save_ToolScroll", {
        top: this.scrollInfo.top,
        left: this.scrollInfo.left
      });

      this.calcPosition();
    },
    calcPosition() {
      // 计算滚动条位置
      if (this.showScrollY) {
        this.handleY.top =
          (this.scrollInfo.top * this.visibleData.height) /
          this.TOOL.option.height;
      }
      if (this.showScrollX) {
        this.handleX.left =
          (this.scrollInfo.left * this.visibleData.width) /
          this.TOOL.option.width;
      }
    },
    dragHandleDown(action) {
      // mouseDown事件调用方法
      if (action === "y") {
        this.handleYDown = this.handleY.top;
      } else if (action === "x") {
        this.handleXDown = this.handleX.left;
      }
    },
    dragHandleMove(d, action) {
      // mouseMove事件调用方法
      let newVal = 0;
      if (action === "y") {
        newVal = this.handleYDown + d.y;
        if (newVal <= 0) {
          newVal = 0;
        } else if (newVal >= this.visibleData.height - this.handleY.height) {
          newVal = this.visibleData.height - this.handleY.height;
        }
        this.handleY.top = newVal;
        this.$refs.scrollContent.scrollTop =
          (newVal / this.visibleData.height) * this.TOOL.option.height;
      } else if (action === "x") {
        newVal = this.handleXDown + d.x;
        if (newVal <= 0) {
          newVal = 0;
        } else if (newVal >= this.visibleData.width - this.handleX.width) {
          newVal = this.visibleData.width - this.handleX.width;
        }
        this.handleX.left = newVal;
        this.$refs.scrollContent.scrollLeft =
          (newVal / this.visibleData.width) * this.TOOL.option.width;
      }
    },
    dragHandleUp(action) {
      if (action === "y") {
        this.handleYDown = 0;
      } else if (action === "x") {
        this.handleXDown = 0;
      }
      // 改变vuex中scroll数据
      this.$store.commit("save_ToolScroll", {
        top: this.$refs.scrollContent.scrollTop,
        left: this.$refs.scrollContent.scrollLeft
      });

      // 重置画布偏移位置
      this.TOOL.changePfix({
        surplusY:
          this.TopNav_Size.height + 40 - this.$refs.scrollContent.scrollTop,
        surplusX:
          this.MaterialPane_Size.width - this.$refs.scrollContent.scrollLeft
      });
    }
  },
  components: {
    setPathAnim,
    setCamera
  },
  directives: {
    dragHandle(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        action = "",
        dis = {
          x: 0,
          y: 0
        };

      mousemove = e => {
        e.preventDefault();
        let d = {
          x: e.pageX - dis.x,
          y: e.pageY - dis.y
        };

        _this.dragHandleMove(d, action);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        _this.dragHandle = false;

        _this.dragHandleUp(action);
      };

      el.onmousedown = e => {
        e.preventDefault();
        _this.dragHandle = true;
        action = e.target.dataset.action;
        dis.x = e.pageX;
        dis.y = e.pageY;

        _this.dragHandleDown(action);

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };
    }
  }
};
</script>

<style scoped lang="scss">
.scroll-visible {
  position: relative;
  box-sizing: border-box;
}
.scroll-content {
  display: block;
  overflow: scroll;
  width: calc(100% + 19px);
  height: calc(100% + 120px);
  box-sizing: border-box;
  position: relative;
  z-index: 100;
}
.scroll-dragger {
  position: absolute;
  z-index: 105;
}
.scroll-dragger.scroll-y {
  top: 0px;
  width: 12px;
  right: 0px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);

  .handle-y {
    width: 8px;
    position: relative;
    height: 50%;
    left: 4px;
    background: rgba(219, 219, 223, 0.9);
    cursor: pointer;

    &:hover {
      background: rgba(181, 179, 179, 0.9);
    }
  }
}
.scroll-dragger.scroll-x {
  bottom: 5px;
  width: 100%;
  left: 0;
  height: 12px;
  background-color: rgba(0, 0, 0, 0);

  .handle-x {
    width: 50%;
    position: relative;
    top: 9px;
    height: 8px;
    background: rgba(219, 219, 223, 0.9);
    cursor: pointer;

    &:hover {
      background: rgba(181, 179, 179, 0.9);
    }
  }
}

.loading-box {
  position: absolute;
  z-index: 25;
  background: rgba(255, 255, 255, 0.5);
  width: 150px;
  height: 70px;
  border-radius: 5px;
  line-height: 70px;
}

.vip-mask {
  position: absolute;
  font-weight: bold;
  z-index: 9999;

  > div {
    color: #fff;
    opacity: 0.15;
    text-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
  }

  > div.contain-vips {
    width: 100%;
    height: 97%;
    margin-top: 1%;
    opacity: 1;
    background: url("../../../static/animengine/img/icon-default-vip-mask.png")
      no-repeat center;
    background-size: contain;
  }
}
.preview-watermark {
  position: absolute;
  z-index: 9999;
}

/deep/ .matting {
  &-control-el {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
  &-btns {
    position: absolute;
    left: 0;
    top: -32px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    min-width: 86px;
    margin-bottom: 10px;
    .btn {
      width: 42px;
      height: 22px;
      background-color: #f0f0f8;
      text-align: center;
      line-height: 22px;
      font-size: 12px;
      color: #474261;
      cursor: pointer;
      &:hover {
        color: rgba(71,66,97, .7);
      }
      &:nth-child(1) {
        margin-right: 1px;
      }
      &.gray {
        background-color: #f6f6f6;
        color: #d5d5d5;
      }
    }
  }
  &-shelter {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, .8);
  }
}
/deep/ .loadEffect{
    width: 32px;
    height: 32px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -16px;
    margin-top: -16px;
    z-index: 1;
    transform: scale(1);
    span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #6565FF;
      position: absolute;
      animation: loadEffect-load 1.04s ease infinite;
      &:nth-child(1){
          left: 0;
          top: 50%;
          margin-top:-5px;
          animation-delay:0.13s;
      }
      &:nth-child(2){
          left: 4px;
          top: 4px;
          animation-delay:0.26s;
      }
      &:nth-child(3){
          left: 50%;
          top: 0;
          margin-left: -4px;
          animation-delay:0.39s;
      }
      &:nth-child(4){
          top: 4px;
          right:4px;
          animation-delay:0.52s;
      }
      &:nth-child(5){
          right: 0;
          top: 50%;
          margin-top:-4px;
          animation-delay:0.65s;
      }
      &:nth-child(6){
          right: 4px;
          bottom:4px;
          animation-delay:0.78s;
      }
      &:nth-child(7){
          bottom: 0;
          left: 50%;
          margin-left: -4px;
          animation-delay:0.91s;
      }
      &:nth-child(8){
          bottom: 4px;
          left: 4px;
          animation-delay:1.04s;
      }
          }
}
@keyframes loadEffect-load {
    0%{
        transform: scale(1);
        opacity: 1;
    }
    100%{
        transform: scale(.3);
        opacity: 0.5;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/editor.vue